import { useState, useEffect } from "react";
import Block from './block1';

const EditableBlockList = ({ onHospitalisationChange }) => {
    const [hospitalisation, setHospitalisation] = useState(null);
    const [notes, setNotes] = useState("");
    const [duration, setDuration] = useState("5 days");

    const handleRadioChange = (event) => {
        const value = event.target.value;
        setHospitalisation(value);
    };

    const handleNotesChange = (newNotes) => {
        setNotes(newNotes);  // Mise à jour des notes
    };

    const handleDurationChange = (newDuration) => {
        setDuration(newDuration);
    };

    // Envoi automatique des données au parent lorsque l'état change
    useEffect(() => {
        const formData = {
            hospitalisation: hospitalisation === "yes" ? "yes" : "no",
            notes,
            duration,
        };
        
        // Envoi des données au parent
        onHospitalisationChange(formData);
    }, [hospitalisation, notes, duration]); 

    return (
        <div>
            <div className="d-flex flex-column ms-5 mb-3">
                <div>
                    <strong>Patient needs Hospitalisation</strong>
                </div>
                <div className="d-flex mt-3">
                    <div>
                        <input
                            type="radio"
                            name="hospitalisation"
                            className="form-check-input"
                            id="consent1"
                            value="yes"
                            checked={hospitalisation === "yes"}
                            onChange={handleRadioChange}
                        />
                        <label htmlFor="consent1" className="form-check-label">
                            Yes
                        </label>
                    </div>
                    <div className="ms-4">
                        <input
                            type="radio"
                            name="hospitalisation"
                            className="form-check-input"
                            id="consent2"
                            value="no"
                            checked={hospitalisation === "no"}
                            onChange={handleRadioChange}
                        />
                        <label htmlFor="consent2" className="form-check-label">
                            No
                        </label>
                    </div>
                </div>
            </div>

            {hospitalisation === "yes" && (
                <>
                    <div className="mt-4 mb-3">
                        <Block
                            initialLabel="Notes for nurses about hospitalisation"
                            initialContent={notes}  // Valeur des notes passée comme prop
                            inputType="text"
                            onContentChange={handleNotesChange}  // Fonction onContentChange pour mettre à jour les notes
                        />
                    </div>
                    <div className="mt-4 mb-3">
                        <Block
                            initialLabel="Duration"
                            initialContent={duration}
                            inputType="text"
                            onContentChange={handleDurationChange}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default EditableBlockList;
